<footer class="w-full">

  <!-- DESKTOP -->
  <div class="hidden lg:flex w-full justify-center">
    <div class="flex flex-col items-center w-full max-w-[1280px] px-[40px]">

      <!-- Fila 1: Dirección, Teléfono, Email -->
      <div class="flex w-[1280px] h-[55px] px-[76px] py-[8px] justify-between items-center content-center gap-y-[8px] flex-wrap">
        <p class="text-neutral-color-neutral-12 font-inter text-[10px] font-light leading-[16px] tracking-[0.04px] whitespace-nowrap">
          {{ 'FOOTER.ADDRESS_LABEL' | translate }} {{ publicConfig.contact().address }}
        </p>
        <a [href]="publicConfig.contact().phoneHref" target="_blank" rel="noopener noreferrer"
          class="text-neutral-color-neutral-12 font-inter text-[10px] font-light leading-[16px] tracking-[0.04px] whitespace-nowrap hover:underline">
          {{ 'FOOTER.PHONE_LABEL' | translate }} {{ publicConfig.contact().phone }}
        </a>
        <a [href]="publicConfig.contact().emailHref"
          class="text-neutral-color-neutral-12 font-inter text-[10px] font-light leading-[16px] tracking-[0.04px] whitespace-nowrap hover:underline">
          {{ 'FOOTER.EMAIL_LABEL' | translate }} {{ publicConfig.contact().email }}
        </a>
      </div>

      <!-- Separador -->
      <div class="flex h-[21px] py-[10px] items-center w-full overflow-hidden">
        <div class="h-[0.6px] bg-neutral-color-neutral-6 w-full"></div>
      </div>

      <!-- Fila 2: Copyright, Redes Sociales, Enlaces Legales -->
      <div class="flex w-[1280px] h-[55px] px-[76px] py-[8px] justify-between items-center content-center gap-y-[8px] flex-wrap">
        <div class="flex items-center">
          <span class="text-neutral-color-neutral-12 font-inter text-[10px] font-light leading-[16px] tracking-[0.04px] whitespace-nowrap">
            © {{ currentYear }} {{ 'FOOTER.RIGHTS' | translate }}
          </span>
        </div>

        <div class="flex items-start gap-[32px]">
          <a [href]="publicConfig.social().facebook" target="_blank" rel="noopener noreferrer" aria-label="Facebook"
            class="social-link social-link--facebook">
            <span class="social-icon social-icon--facebook" aria-hidden="true"></span>
          </a>
          <a [href]="publicConfig.social().instagram" target="_blank" rel="noopener noreferrer" aria-label="Instagram"
            class="social-link social-link--instagram">
            <span class="social-icon social-icon--instagram" aria-hidden="true"></span>
          </a>
          <a [href]="publicConfig.social().youtube" target="_blank" rel="noopener noreferrer" aria-label="YouTube"
            class="social-link social-link--youtube">
            <span class="social-icon social-icon--youtube" aria-hidden="true"></span>
          </a>
          <a [href]="publicConfig.social().whatsapp" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"
            class="social-link social-link--whatsapp">
            <span class="social-icon social-icon--whatsapp" aria-hidden="true"></span>
          </a>
          <a [href]="publicConfig.social().tiktok" target="_blank" rel="noopener noreferrer" aria-label="TikTok"
            class="social-link social-link--tiktok">
            <span class="social-icon social-icon--tiktok" aria-hidden="true"></span>
          </a>
        </div>

        <div class="flex items-center gap-[12px]">
          <a [href]="docs.legal" target="_blank" rel="noopener noreferrer"
            class="text-neutral-color-neutral-12 font-inter text-[10px] font-light leading-[16px] tracking-[0.04px] whitespace-nowrap hover:underline">
            {{ 'FOOTER.LEGAL' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- TABLET & MOBILE: tab bar compartida -->
  <app-tab-bar [items]="tabItems" />

</footer>
